import React from 'react';
import VisibilitySensor from "react-visibility-sensor";
import cell21 from "../../../assets/images/home/cell-2/1.svg";
import tube from "../../../assets/images/icons/tube.svg";

let thisComponent;

class Pillars extends React.Component {
	constructor(props) {
	  super(props);
	  this.state = {
		  isVisible: null
	  };
	};

	componentWillMount() {
		thisComponent = this;
	}

	onVisibilityChange(isVisible) {
		if (isVisible) { // Solamente cambia visibilidad a TRUE
			thisComponent.setState({isVisible})
		}
	}

	render() {
		return (
			<VisibilitySensor
				onChange={this.onVisibilityChange}
			>
				<section className={`pillars ${this.state.isVisible ? "-visible" : "-hidden"}`}>
					<div className="pillars__wrapper container">
						<h2 className="subtitle">Nuestros pilares</h2>
						<ul className="pillars__list">
							<li className="pillars__item">
								<img src={tube} alt="" className="pillars__icon"/>
								<h3 className="title"><strong>Experiencia</strong> de más de 30 años</h3>
							</li>
							<li className="pillars__item">
								<img src={tube} alt="" className="pillars__icon"/>
								<h3 className="title"><strong>Compromiso</strong> en cada tarea</h3>
							</li>
							<li className="pillars__item">
								<img src={tube} alt="" className="pillars__icon"/>
								<h3 className="title"><strong>Calidad</strong> y profesionalismo</h3>
							</li>
							<li className="pillars__item">
								<img src={tube} alt="" className="pillars__icon"/>
								<h3 className="title"><strong>Tecnología</strong> de avanzada</h3>
							</li>
						</ul>
					</div>
					<img src={cell21} alt="" className="pillars__cell-image"/>
				</section>
			</VisibilitySensor>
		)
	}
};

export default Pillars;